// =============================================================================
// Permission constants — used as type-safe references throughout the app.
// =============================================================================
export const PERMISSIONS = {
  // CRM & Customers
  VIEW_CUSTOMER: 'crm.customer.view',
  CREATE_CUSTOMER: 'crm.customer.create',
  EDIT_CUSTOMER: 'crm.customer.edit',
  DELETE_CUSTOMER: 'crm.customer.delete',

  VIEW_VENDOR: 'crm.vendor.view',
  CREATE_VENDOR: 'crm.vendor.create',
  EDIT_VENDOR: 'crm.vendor.edit',
  DELETE_VENDOR: 'crm.vendor.delete',

  VIEW_COMMISSION_AGENT: 'crm.commission_agent.view',
  CREATE_COMMISSION_AGENT: 'crm.commission_agent.create',
  EDIT_COMMISSION_AGENT: 'crm.commission_agent.edit',
  DELETE_COMMISSION_AGENT: 'crm.commission_agent.delete',

  VIEW_OPPORTUNITY: 'crm.opportunity.view',
  CREATE_OPPORTUNITY: 'crm.opportunity.create',
  EDIT_OPPORTUNITY: 'crm.opportunity.edit',
  DELETE_OPPORTUNITY: 'crm.opportunity.delete',
  UPDATE_OPPORTUNITY_STATUS: 'crm.opportunity.update_status',

  VIEW_TICKET: 'crm.ticket.view',
  CREATE_TICKET: 'crm.ticket.create',
  EDIT_TICKET: 'crm.ticket.edit',
  DELETE_TICKET: 'crm.ticket.delete',
  UPDATE_TICKET_STATUS: 'crm.ticket.update_status',

  VIEW_ACTIVITY: 'crm.activity.view',
  CREATE_ACTIVITY: 'crm.activity.create',
  EDIT_ACTIVITY: 'crm.activity.edit',
  DELETE_ACTIVITY: 'crm.activity.delete',

  VIEW_PROJECT: 'crm.project.view',
  CREATE_PROJECT: 'crm.project.create',
  EDIT_PROJECT: 'crm.project.edit',
  DELETE_PROJECT: 'crm.project.delete',

  VIEW_TASK: 'crm.task.view',
  CREATE_TASK: 'crm.task.create',
  EDIT_TASK: 'crm.task.edit',
  DELETE_TASK: 'crm.task.delete',
  UPDATE_TASK_PROGRESS: 'crm.task.update_progress',
  APPROVE_TASK_PROGRESS: 'crm.task.approve_progress',
  VERIFY_TASK: 'crm.task.verify',

  // Performance & KPI
  VIEW_PERFORMANCE_DASHBOARD: 'hr.performance.view',
  MANAGE_PERFORMANCE: 'hr.performance.manage',
  CONFIGURE_KPI: 'hr.performance.configure',
  FINALIZE_PERFORMANCE_PERIOD: 'hr.performance.finalize',
  VIEW_EMPLOYEE_TARGET: 'hr.performance.view',
  MANAGE_EMPLOYEE_TARGET: 'hr.performance.manage',

  VIEW_TIMESHEET: 'crm.timesheet.view',
  CREATE_TIMESHEET: 'crm.timesheet.create',
  EDIT_TIMESHEET: 'crm.timesheet.edit',
  DELETE_TIMESHEET: 'crm.timesheet.delete',

  // Loyalty
  VIEW_LOYALTY_PROGRAM: 'loyalty.program.view',
  CREATE_LOYALTY_PROGRAM: 'loyalty.program.create',
  EDIT_LOYALTY_PROGRAM: 'loyalty.program.edit',
  DELETE_LOYALTY_PROGRAM: 'loyalty.program.delete',
  MANAGE_LOYALTY: 'loyalty.program.manage',

  // Inventory & Warehouse
  VIEW_INVENTORY_ITEM: 'inventory.item.view',
  CREATE_INVENTORY_ITEM: 'inventory.item.create',
  EDIT_INVENTORY_ITEM: 'inventory.item.edit',
  DELETE_INVENTORY_ITEM: 'inventory.item.delete',

  VIEW_ITEM_CATEGORY: 'inventory.category.view',
  CREATE_ITEM_CATEGORY: 'inventory.category.create',
  EDIT_ITEM_CATEGORY: 'inventory.category.edit',
  DELETE_ITEM_CATEGORY: 'inventory.category.delete',

  VIEW_WAREHOUSE: 'inventory.warehouse.view',
  CREATE_WAREHOUSE: 'inventory.warehouse.create',
  EDIT_WAREHOUSE: 'inventory.warehouse.edit',
  DELETE_WAREHOUSE: 'inventory.warehouse.delete',

  VIEW_WAREHOUSE_BIN: 'inventory.bin.view',
  CREATE_WAREHOUSE_BIN: 'inventory.bin.create',
  EDIT_WAREHOUSE_BIN: 'inventory.bin.edit',
  DELETE_WAREHOUSE_BIN: 'inventory.bin.delete',

  VIEW_STOCK_TRANSFER: 'inventory.stock_transfer.view',
  CREATE_STOCK_TRANSFER: 'inventory.stock_transfer.create',
  EDIT_STOCK_TRANSFER: 'inventory.stock_transfer.edit',
  DELETE_STOCK_TRANSFER: 'inventory.stock_transfer.delete',
  APPROVE_STOCK_TRANSFER: 'inventory.stock_transfer.approve',

  VIEW_STOCK_ADJUSTMENT: 'inventory.stock_adjustment.view',
  CREATE_STOCK_ADJUSTMENT: 'inventory.stock_adjustment.create',
  EDIT_STOCK_ADJUSTMENT: 'inventory.stock_adjustment.edit',
  DELETE_STOCK_ADJUSTMENT: 'inventory.stock_adjustment.delete',
  APPROVE_STOCK_ADJUSTMENT: 'inventory.stock_adjustment.approve',

  VIEW_CYCLE_COUNT: 'inventory.cycle_count.view',
  CREATE_CYCLE_COUNT: 'inventory.cycle_count.create',
  EDIT_CYCLE_COUNT: 'inventory.cycle_count.edit',
  DELETE_CYCLE_COUNT: 'inventory.cycle_count.delete',

  VIEW_LANDED_COST: 'inventory.landed_cost.view',
  CREATE_LANDED_COST: 'inventory.landed_cost.create',
  EDIT_LANDED_COST: 'inventory.landed_cost.edit',
  DELETE_LANDED_COST: 'inventory.landed_cost.delete',
  APPROVE_LANDED_COST: 'inventory.landed_cost.approve',

  VIEW_BATCH: 'inventory.batch.view',
  CREATE_BATCH: 'inventory.batch.create',
  EDIT_BATCH: 'inventory.batch.edit',
  DELETE_BATCH: 'inventory.batch.delete',

  VIEW_SHIPMENT: 'inventory.shipment.view',
  CREATE_SHIPMENT: 'inventory.shipment.create',
  EDIT_SHIPMENT: 'inventory.shipment.edit',
  DELETE_SHIPMENT: 'inventory.shipment.delete',

  VIEW_UNIT: 'inventory.unit.view',
  CREATE_UNIT: 'inventory.unit.create',
  EDIT_UNIT: 'inventory.unit.edit',
  DELETE_UNIT: 'inventory.unit.delete',

  VIEW_BRAND: 'inventory.brand.view',
  CREATE_BRAND: 'inventory.brand.create',
  EDIT_BRAND: 'inventory.brand.edit',
  DELETE_BRAND: 'inventory.brand.delete',

  // Procurement
  VIEW_PURCHASE: 'procurement.invoice.view',
  CREATE_PURCHASE: 'procurement.invoice.create',
  EDIT_PURCHASE: 'procurement.invoice.edit',
  DELETE_PURCHASE: 'procurement.invoice.delete',
  APPROVE_PURCHASES: 'procurement.invoice.approve',

  VIEW_PURCHASE_ORDER: 'procurement.order.view',
  CREATE_PURCHASE_ORDER: 'procurement.order.create',
  EDIT_PURCHASE_ORDER: 'procurement.order.edit',
  DELETE_PURCHASE_ORDER: 'procurement.order.delete',
  APPROVE_PURCHASE_ORDER: 'procurement.order.approve',

  VIEW_DEBIT_NOTE: 'procurement.debit_note.view',
  CREATE_DEBIT_NOTE: 'procurement.debit_note.create',
  EDIT_DEBIT_NOTE: 'procurement.debit_note.edit',
  DELETE_DEBIT_NOTE: 'procurement.debit_note.delete',

  VIEW_PURCHASE_RETURN: 'procurement.return.view',
  CREATE_PURCHASE_RETURN: 'procurement.return.create',
  EDIT_PURCHASE_RETURN: 'procurement.return.edit',
  DELETE_PURCHASE_RETURN: 'procurement.return.delete',

  VIEW_PURCHASE_REQUISITION: 'procurement.requisition.view',
  CREATE_PURCHASE_REQUISITION: 'procurement.requisition.create',
  EDIT_PURCHASE_REQUISITION: 'procurement.requisition.edit',
  DELETE_PURCHASE_REQUISITION: 'procurement.requisition.delete',
  APPROVE_PURCHASE_REQUISITION: 'procurement.requisition.approve',

  VIEW_GRN: 'procurement.grn.view',
  CREATE_GRN: 'procurement.grn.create',
  EDIT_GRN: 'procurement.grn.edit',
  DELETE_GRN: 'procurement.grn.delete',

  // Sales
  VIEW_QUOTATION: 'sales.quotation.view',
  CREATE_QUOTATION: 'sales.quotation.create',
  EDIT_QUOTATION: 'sales.quotation.edit',
  DELETE_QUOTATION: 'sales.quotation.delete',

  VIEW_INVOICE: 'sales.invoice.view',
  CREATE_INVOICE: 'sales.invoice.create',
  EDIT_INVOICE: 'sales.invoice.edit',
  DELETE_INVOICE: 'sales.invoice.delete',
  APPROVE_INVOICES: 'sales.invoice.approve',

  VIEW_CREDIT_NOTE: 'sales.credit_note.view',
  CREATE_CREDIT_NOTE: 'sales.credit_note.create',
  EDIT_CREDIT_NOTE: 'sales.credit_note.edit',
  DELETE_CREDIT_NOTE: 'sales.credit_note.delete',

  VIEW_SALES_ORDER: 'sales.order.view',
  CREATE_SALES_ORDER: 'sales.order.create',
  EDIT_SALES_ORDER: 'sales.order.edit',
  DELETE_SALES_ORDER: 'sales.order.delete',

  VIEW_SALES_RETURN: 'sales.return.view',
  CREATE_SALES_RETURN: 'sales.return.create',
  EDIT_SALES_RETURN: 'sales.return.edit',
  DELETE_SALES_RETURN: 'sales.return.delete',

  VIEW_INSTALLMENT_SALE: 'sales.installment.view',
  CREATE_INSTALLMENT_SALE: 'sales.installment.create',
  EDIT_INSTALLMENT_SALE: 'sales.installment.edit',
  DELETE_INSTALLMENT_SALE: 'sales.installment.delete',

  // Finance & Accounting
  VIEW_JOURNAL_ENTRY: 'finance.journal_entry.view',
  CREATE_JOURNAL_ENTRY: 'finance.journal_entry.create',
  EDIT_JOURNAL_ENTRY: 'finance.journal_entry.edit',
  DELETE_JOURNAL_ENTRY: 'finance.journal_entry.delete',

  VIEW_RECURRING_JOURNAL_ENTRY: 'finance.recurring_entry.view',
  CREATE_RECURRING_JOURNAL_ENTRY: 'finance.recurring_entry.create',
  EDIT_RECURRING_JOURNAL_ENTRY: 'finance.recurring_entry.edit',
  DELETE_RECURRING_JOURNAL_ENTRY: 'finance.recurring_entry.delete',
  APPROVE_RECURRING_JOURNAL_ENTRY: 'finance.recurring_entry.approve',

  VIEW_EXPENSE: 'finance.expense.view',
  CREATE_EXPENSE: 'finance.expense.create',
  EDIT_EXPENSE: 'finance.expense.edit',
  DELETE_EXPENSE: 'finance.expense.delete',
  APPROVE_EXPENSES: 'finance.expense.approve',

  VIEW_PAYMENT: 'finance.payment.view',
  CREATE_PAYMENT: 'finance.payment.create',
  EDIT_PAYMENT: 'finance.payment.edit',
  DELETE_PAYMENT: 'finance.payment.delete',

  VIEW_FIXED_ASSET: 'finance.fixed_asset.view',
  CREATE_FIXED_ASSET: 'finance.fixed_asset.create',
  EDIT_FIXED_ASSET: 'finance.fixed_asset.edit',
  DELETE_FIXED_ASSET: 'finance.fixed_asset.delete',

  VIEW_LEASE: 'finance.lease.view',
  CREATE_LEASE: 'finance.lease.create',
  EDIT_LEASE: 'finance.lease.edit',
  DELETE_LEASE: 'finance.lease.delete',
  APPROVE_LEASE: 'finance.lease.approve',

  VIEW_BUDGET: 'finance.budget.view',
  CREATE_BUDGET: 'finance.budget.create',
  EDIT_BUDGET: 'finance.budget.edit',
  DELETE_BUDGET: 'finance.budget.delete',
  APPROVE_BUDGET: 'finance.budget.approve',

  VIEW_FINANCIAL_REPORTS: 'finance.reports.view',
  VIEW_STOCK_REPORTS: 'inventory.reports.view',
  VIEW_SALES_REPORTS: 'sales.reports.view',
  VIEW_PURCHASE_REPORTS: 'procurement.reports.view',

  // HR
  VIEW_EMPLOYEE: 'hr.employee.view',
  CREATE_EMPLOYEE: 'hr.employee.create',
  EDIT_EMPLOYEE: 'hr.employee.edit',
  DELETE_EMPLOYEE: 'hr.employee.delete',
  VIEW_ATTENDANCE: 'hr.attendance.view',
  MANAGE_PAYROLL: 'hr.payroll.manage',
  VIEW_DEPARTMENT: 'hr.department.view',
  CREATE_DEPARTMENT: 'hr.department.create',
  EDIT_DEPARTMENT: 'hr.department.edit',
  DELETE_DEPARTMENT: 'hr.department.delete',
  VIEW_LEAVE: 'hr.leave.view',
  CREATE_LEAVE: 'hr.leave.create',
  DELETE_LEAVE: 'hr.leave.delete',
  APPROVE_LEAVE: 'hr.leave.approve',
  VIEW_PERFORMANCE: 'hr.performance.view',
  CREATE_PERFORMANCE: 'hr.performance.create',
  DELETE_PERFORMANCE: 'hr.performance.delete',
  VIEW_RECRUITING: 'hr.recruiting.view',
  CREATE_RECRUITING: 'hr.recruiting.create',
  DELETE_RECRUITING: 'hr.recruiting.delete',
  VIEW_TRAINING: 'hr.training.view',
  CREATE_TRAINING: 'hr.training.create',
  DELETE_TRAINING: 'hr.training.delete',

  // Admin & System
  VIEW_USER: 'admin.user.view',
  CREATE_USER: 'admin.user.create',
  EDIT_USER: 'admin.user.edit',
  DELETE_USER: 'admin.user.delete',
  VIEW_TAX_RATE: 'admin.tax.view',
  CREATE_TAX_RATE: 'admin.tax.create',
  EDIT_TAX_RATE: 'admin.tax.edit',
  DELETE_TAX_RATE: 'admin.tax.delete',
  MANAGE_SETTINGS: 'admin.settings.manage',
  VIEW_AUDIT_LOGS: 'admin.audit.view',
  BACKUP_RESTORE: 'admin.backup.manage',
  VIEW_SUPER_ADMIN: 'admin.superadmin.view',

  // POS
  VIEW_POS_SALE: 'pos.sale.view',
  CREATE_POS_SALE: 'pos.sale.create',
  EDIT_POS_SALE: 'pos.sale.edit',
  DELETE_POS_SALE: 'pos.sale.delete',
  MANAGE_POS: 'pos.sale.manage',

  // AI Document Processing
  VIEW_AI_DOCUMENT: 'ai.document.view',
  UPLOAD_AI_DOCUMENT: 'ai.document.upload',
  APPROVE_AI_DOCUMENT: 'ai.document.approve',
  DELETE_AI_DOCUMENT: 'ai.document.delete',
  MANAGE_AI_DLQ: 'admin.audit.view',

  // Manufacturing
  VIEW_BOM: 'manufacturing.bom.view',
  CREATE_BOM: 'manufacturing.bom.create',
  EDIT_BOM: 'manufacturing.bom.edit',
  DELETE_BOM: 'manufacturing.bom.delete',

  VIEW_PRODUCTION_ORDER: 'manufacturing.production_order.view',
  CREATE_PRODUCTION_ORDER: 'manufacturing.production_order.create',
  EDIT_PRODUCTION_ORDER: 'manufacturing.production_order.edit',
  DELETE_PRODUCTION_ORDER: 'manufacturing.production_order.delete',

  VIEW_WORK_CENTER: 'manufacturing.work_center.view',
  CREATE_WORK_CENTER: 'manufacturing.work_center.create',
  EDIT_WORK_CENTER: 'manufacturing.work_center.edit',
  DELETE_WORK_CENTER: 'manufacturing.work_center.delete',

  // Trade & International Commerce
  VIEW_TRADE_SHIPMENT: 'trade.shipment.view',
  CREATE_TRADE_SHIPMENT: 'trade.shipment.create',
  EDIT_TRADE_SHIPMENT: 'trade.shipment.edit',
  DELETE_TRADE_SHIPMENT: 'trade.shipment.delete',
  APPROVE_TRADE_SHIPMENT: 'trade.shipment.approve',

  VIEW_TRADE_LC: 'trade.lc.view',
  CREATE_TRADE_LC: 'trade.lc.create',
  EDIT_TRADE_LC: 'trade.lc.edit',
  DELETE_TRADE_LC: 'trade.lc.delete',  // FIX: Added missing DELETE permission
  APPROVE_TRADE_LC: 'trade.lc.approve',

  VIEW_BANK_GUARANTEE: 'trade.bank_guarantee.view',
  CREATE_BANK_GUARANTEE: 'trade.bank_guarantee.create',
  EDIT_BANK_GUARANTEE: 'trade.bank_guarantee.edit',
  DELETE_BANK_GUARANTEE: 'trade.bank_guarantee.delete',  // FIX: Added missing DELETE permission
  APPROVE_BANK_GUARANTEE: 'trade.bank_guarantee.approve',  // FIX: Added missing APPROVE permission
  CLAIM_BANK_GUARANTEE: 'trade.bank_guarantee.claim',  // FIX: Added missing CLAIM permission
  ISSUE_BANK_GUARANTEE: 'trade.bank_guarantee.issue',  // FIX: Added missing ISSUE permission

  VIEW_TRADE_CUSTOMS: 'trade.customs.view',
  CREATE_TRADE_CUSTOMS: 'trade.customs.create',
  EDIT_TRADE_CUSTOMS: 'trade.customs.edit',
  DELETE_TRADE_CUSTOMS: 'trade.customs.delete',  // FIX: Added missing DELETE permission

  VIEW_HS_CODE: 'trade.hs_code.view',
  CREATE_HS_CODE: 'trade.hs_code.create',
  EDIT_HS_CODE: 'trade.hs_code.edit',
  DELETE_HS_CODE: 'trade.hs_code.delete',

  VIEW_TRADE_COMPLIANCE: 'trade.compliance.view',
  SCREEN_TRADE_COMPLIANCE: 'trade.compliance.screen',
  OVERRIDE_TRADE_COMPLIANCE: 'trade.compliance.override',
  CREATE_TRADE_COMPLIANCE: 'trade.compliance.create',  // FIX: Added missing CREATE permission
  EDIT_TRADE_COMPLIANCE: 'trade.compliance.edit',  // FIX: Added missing EDIT permission
  DELETE_TRADE_COMPLIANCE: 'trade.compliance.delete',  // FIX: Added missing DELETE permission

  // EAM — Enterprise Asset Management
  VIEW_EAM_MAINTENANCE: 'eam.maintenance.view',
  CREATE_EAM_MAINTENANCE: 'eam.maintenance.create',
  EDIT_EAM_MAINTENANCE: 'eam.maintenance.edit',
  DELETE_EAM_MAINTENANCE: 'eam.maintenance.delete',
  APPROVE_EAM_MAINTENANCE: 'eam.maintenance.approve',

  VIEW_EAM_INSPECTION: 'eam.inspection.view',
  CREATE_EAM_INSPECTION: 'eam.inspection.create',
  EDIT_EAM_INSPECTION: 'eam.inspection.edit',
  DELETE_EAM_INSPECTION: 'eam.inspection.delete',

  VIEW_EAM_WARRANTY: 'eam.warranty.view',
  CREATE_EAM_WARRANTY: 'eam.warranty.create',
  EDIT_EAM_WARRANTY: 'eam.warranty.edit',
  DELETE_EAM_WARRANTY: 'eam.warranty.delete',

  VIEW_EAM_ACQUISITION: 'eam.acquisition.view',
  CREATE_EAM_ACQUISITION: 'eam.acquisition.create',
  EDIT_EAM_ACQUISITION: 'eam.acquisition.edit',
  DELETE_EAM_ACQUISITION: 'eam.acquisition.delete',
  APPROVE_EAM_ACQUISITION: 'eam.acquisition.approve',

  VIEW_EAM_TRANSFER: 'eam.transfer.view',
  CREATE_EAM_TRANSFER: 'eam.transfer.create',
  EDIT_EAM_TRANSFER: 'eam.transfer.edit',
  DELETE_EAM_TRANSFER: 'eam.transfer.delete',

  VIEW_EAM_CATEGORY: 'eam.category.view',
  CREATE_EAM_CATEGORY: 'eam.category.create',
  EDIT_EAM_CATEGORY: 'eam.category.edit',
  DELETE_EAM_CATEGORY: 'eam.category.delete',

  VIEW_EAM_DISPOSAL: 'eam.disposal.view',
  CREATE_EAM_DISPOSAL: 'eam.disposal.create',
  EDIT_EAM_DISPOSAL: 'eam.disposal.edit',
  DELETE_EAM_DISPOSAL: 'eam.disposal.delete',

  // Sales Receipt & Procurement Payment
  VIEW_SALES_RECEIPT: 'sales.receipt.view',
  CREATE_SALES_RECEIPT: 'sales.receipt.create',
  EDIT_SALES_RECEIPT: 'sales.receipt.edit',
  DELETE_SALES_RECEIPT: 'sales.receipt.delete',

  VIEW_PROCUREMENT_PAYMENT: 'procurement.payment.view',
  CREATE_PROCUREMENT_PAYMENT: 'procurement.payment.create',
  EDIT_PROCUREMENT_PAYMENT: 'procurement.payment.edit',
  DELETE_PROCUREMENT_PAYMENT: 'procurement.payment.delete',
};

// =============================================================================
// Legacy role permission lists — flat arrays used as a fallback when the user
// object has a plain `role` string but no `userRole.permissions` object.
// =============================================================================
export const ROLE_PERMISSIONS = {
  admin: Object.values(PERMISSIONS).filter(p => p !== 'admin.backup.manage' && p !== 'admin.superadmin.view'),
  manager: [
    'crm.customer.view', 'crm.customer.create', 'crm.customer.edit',
    'crm.vendor.view', 'crm.vendor.create', 'crm.vendor.edit',
    'crm.commission_agent.view', 'crm.commission_agent.create', 'crm.commission_agent.edit',
    'crm.opportunity.view', 'crm.opportunity.create', 'crm.opportunity.edit', 'crm.opportunity.update_status',
    'crm.ticket.view', 'crm.ticket.create', 'crm.ticket.edit', 'crm.ticket.update_status',
    'crm.activity.view', 'crm.activity.create', 'crm.activity.edit',
    'crm.project.view', 'crm.project.create', 'crm.project.edit',
    'crm.task.view', 'crm.task.create', 'crm.task.edit',
    'crm.timesheet.view', 'crm.timesheet.create', 'crm.timesheet.edit',
    'loyalty.program.view', 'loyalty.program.create', 'loyalty.program.edit', 'loyalty.program.manage',
    'inventory.item.view', 'inventory.item.create', 'inventory.item.edit',
    'inventory.category.view', 'inventory.category.create', 'inventory.category.edit',
    'inventory.warehouse.view', 'inventory.warehouse.create', 'inventory.warehouse.edit',
    'inventory.bin.view', 'inventory.bin.create', 'inventory.bin.edit',
    'inventory.stock_transfer.view', 'inventory.stock_transfer.create', 'inventory.stock_transfer.edit', 'inventory.stock_transfer.approve',
    'inventory.stock_adjustment.view', 'inventory.stock_adjustment.create', 'inventory.stock_adjustment.edit',
    'inventory.cycle_count.view', 'inventory.cycle_count.create', 'inventory.cycle_count.edit',
    'inventory.landed_cost.view', 'inventory.landed_cost.create', 'inventory.landed_cost.edit',
    'inventory.batch.view', 'inventory.batch.create', 'inventory.batch.edit',
    'inventory.shipment.view', 'inventory.shipment.create', 'inventory.shipment.edit',
    'inventory.unit.view', 'inventory.unit.create', 'inventory.unit.edit',
    'inventory.brand.view', 'inventory.brand.create', 'inventory.brand.edit',
    'procurement.invoice.view', 'procurement.invoice.create', 'procurement.invoice.edit',
    'procurement.order.view', 'procurement.order.create', 'procurement.order.edit', 'procurement.order.approve',
    'procurement.debit_note.view', 'procurement.debit_note.create', 'procurement.debit_note.edit',
    'procurement.return.view', 'procurement.return.create', 'procurement.return.edit',
    'procurement.requisition.view', 'procurement.requisition.create', 'procurement.requisition.edit', 'procurement.requisition.approve',
    'procurement.grn.view', 'procurement.grn.create', 'procurement.grn.edit',
    'sales.quotation.view', 'sales.quotation.create', 'sales.quotation.edit',
    'sales.invoice.view', 'sales.invoice.create', 'sales.invoice.edit', 'sales.invoice.approve',
    'sales.credit_note.view', 'sales.credit_note.create', 'sales.credit_note.edit',
    'sales.order.view', 'sales.order.create', 'sales.order.edit',
    'sales.return.view', 'sales.return.create', 'sales.return.edit',
    'sales.installment.view', 'sales.installment.create', 'sales.installment.edit',
    'finance.journal_entry.view', 'finance.journal_entry.create', 'finance.journal_entry.edit',
    'finance.recurring_entry.view', 'finance.recurring_entry.create', 'finance.recurring_entry.edit',
    'finance.expense.view', 'finance.expense.create', 'finance.expense.edit',
    'finance.payment.view', 'finance.payment.create', 'finance.payment.edit',
    'finance.fixed_asset.view', 'finance.fixed_asset.create', 'finance.fixed_asset.edit',
    'finance.lease.view', 'finance.lease.create', 'finance.lease.edit',
    'finance.budget.view', 'finance.budget.create', 'finance.budget.edit',
    'finance.reports.view', 'finance.reports.balance_sheet', 'finance.reports.profit_loss', 'finance.reports.cash_flow', 'finance.reports.trial_balance', 'finance.reports.general_ledger', 'finance.reports.aged_receivables', 'finance.reports.aged_payables',
    'inventory.reports.view', 'inventory.reports.stock', 'inventory.reports.movement', 'inventory.reports.valuation', 'inventory.reports.low_stock',
    'sales.reports.view', 'procurement.reports.view',
    'hr.employee.view', 'hr.attendance.view', 'hr.department.view',
    'hr.leave.view', 'hr.leave.create', 'hr.leave.approve',
    'hr.performance.view', 'hr.performance.create', 'hr.performance.manage', 'hr.performance.configure', 'hr.performance.finalize',
    'hr.recruiting.view', 'hr.recruiting.create',
    'hr.training.view', 'hr.training.create',
    'admin.user.view', 'admin.tax.view', 'admin.audit.view',
    'pos.sale.view', 'pos.sale.create', 'pos.sale.edit', 'pos.sale.manage',
    'manufacturing.bom.view', 'manufacturing.bom.create', 'manufacturing.bom.edit',
    'manufacturing.production_order.view', 'manufacturing.production_order.create', 'manufacturing.production_order.edit',
    'manufacturing.work_center.view', 'manufacturing.work_center.create', 'manufacturing.work_center.edit',
    // AI Document Processing
    'ai.document.view', 'ai.document.upload', 'ai.document.approve',
    // Trade & International Commerce - Added full trade permissions
    'trade.shipment.view', 'trade.shipment.create', 'trade.shipment.edit', 'trade.shipment.approve',
    'trade.lc.view', 'trade.lc.create', 'trade.lc.edit', 'trade.lc.approve',
    'trade.bank_guarantee.view', 'trade.bank_guarantee.create', 'trade.bank_guarantee.edit',
    'trade.bank_guarantee.approve', 'trade.bank_guarantee.claim', 'trade.bank_guarantee.issue',
    'trade.customs.view', 'trade.customs.create', 'trade.customs.edit',
    'trade.hs_code.view', 'trade.hs_code.create', 'trade.hs_code.edit',
    'trade.compliance.view', 'trade.compliance.screen',
    // EAM
    'eam.maintenance.view', 'eam.maintenance.create', 'eam.maintenance.edit', 'eam.maintenance.delete', 'eam.maintenance.approve',
    'eam.inspection.view', 'eam.inspection.create', 'eam.inspection.edit', 'eam.inspection.delete',
    'eam.warranty.view', 'eam.warranty.create', 'eam.warranty.edit', 'eam.warranty.delete',
    'eam.acquisition.view', 'eam.acquisition.create', 'eam.acquisition.edit', 'eam.acquisition.delete', 'eam.acquisition.approve',
    'eam.transfer.view', 'eam.transfer.create', 'eam.transfer.edit', 'eam.transfer.delete',
    'eam.category.view', 'eam.category.create', 'eam.category.edit', 'eam.category.delete',
    'eam.disposal.view', 'eam.disposal.create', 'eam.disposal.edit', 'eam.disposal.delete',
    // Receipts & Payments
    'sales.receipt.view', 'sales.receipt.create', 'sales.receipt.edit', 'sales.receipt.delete',
    'procurement.payment.view', 'procurement.payment.create', 'procurement.payment.edit', 'procurement.payment.delete',
  ],
  sales: [
    // Full Sales access
    'sales.quotation.view', 'sales.quotation.create', 'sales.quotation.edit', 'sales.quotation.delete',
    'sales.order.view', 'sales.order.create', 'sales.order.edit', 'sales.order.delete',
    'sales.invoice.view', 'sales.invoice.create', 'sales.invoice.edit',
    'sales.credit_note.view', 'sales.credit_note.create',
    'sales.return.view', 'sales.return.create',
    'sales.installment.view', 'sales.installment.create', 'sales.installment.edit',

    // CRM - Customer focus
    'crm.customer.view', 'crm.customer.create', 'crm.customer.edit', 'crm.customer.delete',
    'crm.opportunity.view', 'crm.opportunity.create', 'crm.opportunity.edit', 'crm.opportunity.update_status',
    'crm.ticket.view', 'crm.ticket.create', 'crm.ticket.edit',
    'crm.activity.view', 'crm.activity.create', 'crm.activity.edit',

    // Loyalty programs
    'loyalty.program.view', 'loyalty.program.create', 'loyalty.program.edit', 'loyalty.program.manage',

    // POS
    'pos.sale.view', 'pos.sale.create', 'pos.sale.edit', 'pos.sale.manage',

    // Inventory - View only
    'inventory.item.view',
    'inventory.category.view',

    // Procurement - Requisitions only
    'procurement.requisition.view', 'procurement.requisition.create',

    // Reports - Sales reports only
    'sales.reports.view',

    // Trade - Limited trade access for sales
    'trade.shipment.view',
    'trade.bank_guarantee.view',
    'trade.lc.view',
    'sales.receipt.view', 'sales.receipt.create',
  ],
  employee: [
    'crm.customer.view', 'crm.customer.create',
    'crm.vendor.view', 'crm.commission_agent.view',
    'crm.opportunity.view', 'crm.opportunity.create',
    'crm.ticket.view', 'crm.ticket.create',
    'crm.activity.view', 'crm.activity.create',
    'loyalty.program.view',
    'inventory.item.view',
    'inventory.stock_transfer.view',
    'inventory.stock_adjustment.view',
    'inventory.shipment.view',
    'sales.quotation.view', 'sales.quotation.create', 'sales.quotation.edit',
    'sales.invoice.view', 'sales.invoice.create',
    'sales.credit_note.view', 'sales.credit_note.create',
    'sales.order.view', 'sales.order.create',
    'sales.installment.view', 'sales.installment.create',
    'procurement.invoice.view', 'procurement.debit_note.view',
    'procurement.requisition.view', 'procurement.grn.view',
    'hr.employee.view', 'hr.department.view', 'hr.attendance.view',
    'hr.leave.view', 'hr.leave.create',
    'hr.performance.view', 'hr.recruiting.view', 'hr.training.view',
    'pos.sale.view', 'pos.sale.create',
    // AI Document Processing — upload only, no approve
    'ai.document.view', 'ai.document.upload',
    // Trade - Basic view only
    'trade.shipment.view',
    'trade.bank_guarantee.view',
    // EAM - View only
    'eam.maintenance.view', 'eam.inspection.view',
    // Receipts & Payments
    'sales.receipt.view', 'procurement.payment.view',
  ],
  viewer: [
    'crm.customer.view', 'crm.vendor.view', 'crm.commission_agent.view',
    'crm.opportunity.view', 'crm.ticket.view', 'crm.activity.view',
    'inventory.item.view', 'inventory.stock_transfer.view', 'inventory.stock_adjustment.view',
    'sales.quotation.view', 'sales.invoice.view', 'sales.credit_note.view', 'sales.installment.view',
    'procurement.invoice.view', 'procurement.debit_note.view',
    'hr.employee.view', 'hr.department.view',
    'finance.reports.view', 'finance.lease.view', 'inventory.reports.view', 'sales.reports.view', 'procurement.reports.view',
    'hr.leave.view', 'hr.performance.view', 'hr.recruiting.view', 'hr.training.view',
    'pos.sale.view',
    // AI Document Processing — view only
    'ai.document.view',
    // Trade - View only
    'trade.shipment.view',
    'trade.bank_guarantee.view',
    'trade.lc.view',
    'trade.customs.view',
    'trade.hs_code.view',
    'trade.compliance.view',
    // EAM - View only
    'eam.maintenance.view', 'eam.inspection.view', 'eam.warranty.view', 'eam.acquisition.view',
    'eam.transfer.view', 'eam.category.view', 'eam.disposal.view',
    // Receipts & Payments
    'sales.receipt.view', 'procurement.payment.view',
  ],
};

// =============================================================================
// Complete super_admin permission list.
// =============================================================================
const SUPER_ADMIN_PERMISSIONS = Object.values(PERMISSIONS);

// =============================================================================
// isSuperAdmin — single place to check for super_admin identity.
// =============================================================================
const isSuperAdmin = (user) => {
  const role = (user?.userRole?.name || user?.role || '').toLowerCase().replace(' ', '_');
  return role === 'super_admin';
};

// =============================================================================
// hasPermission(user, permission)
//
// The single authoritative permission check used by:
//   - ProtectedRoute (routing)
//   - AuthContext.hasPermission (exposed to all components)
//   - Layout sidebar filtering
// =============================================================================
export const hasPermission = (user, permission) => {
  if (!user || !permission) return false;

  // 1. Super admin bypasses all checks.
  if (isSuperAdmin(user)) return true;

  // 2. New role system: user.userRole.permissions (flat array of dot-notation strings)
  if (user.userRole?.permissions) {
    const perms = user.userRole.permissions;

    // Flat array format
    if (Array.isArray(perms)) {
      if (perms.includes(permission)) return true;
    }

    // JSON string format
    if (typeof perms === 'string') {
      try {
        const parsed = JSON.parse(perms);
        if (Array.isArray(parsed) && parsed.includes(permission)) return true;
      } catch {
        // Fall through
      }
    }
  }

  // 3. Legacy role string fallback.
  const roleKey = (user.role || user.userRole?.name || '').toLowerCase();
  if (roleKey) {
    const legacyPerms = ROLE_PERMISSIONS[roleKey] || [];
    if (legacyPerms.includes(permission)) return true;
  }

  return false;
};

// =============================================================================
// getUserPermissions(user)
// =============================================================================
export const getUserPermissions = (user) => {
  if (!user) return [];

  // Super admin gets the exhaustive list so hasAnyPermission works correctly.
  if (isSuperAdmin(user)) return SUPER_ADMIN_PERMISSIONS;

  const roleKey = (user.role || user.userRole?.name || '').toLowerCase();
  const legacyPerms = roleKey ? (ROLE_PERMISSIONS[roleKey] || []) : [];

  if (user.userRole?.permissions) {
    const perms = user.userRole.permissions;

    if (Array.isArray(perms)) return [...new Set([...perms, ...legacyPerms])];

    if (typeof perms === 'string') {
      try {
        const parsed = JSON.parse(perms);
        if (Array.isArray(parsed)) return [...new Set([...parsed, ...legacyPerms])];
      } catch {
        return legacyPerms;
      }
    }
  }

  return legacyPerms;
};

// =============================================================================
// hasAnyPermission(user, permissions)
// =============================================================================
export const hasAnyPermission = (user, permissions) => {
  if (!user || !permissions?.length) return false;
  if (isSuperAdmin(user)) return true;
  const userPerms = getUserPermissions(user);
  return permissions.some((p) => userPerms.includes(p));
};

// =============================================================================
// hasAllPermissions(user, permissions)
// =============================================================================
export const hasAllPermissions = (user, permissions) => {
  if (!user || !permissions?.length) return false;
  if (isSuperAdmin(user)) return true;
  const userPerms = getUserPermissions(user);
  return permissions.every((p) => userPerms.includes(p));
};